import { Column } from './types';

export const All_SITE_CONNECTION_REPORT = 'All site connections';

export const ALL_SITE_CONNECTIONS_REPORT_MESSAGE_LINK = "https://ppgpinetree.atlassian.net/wiki/spaces/AE/pages/2366177294/All+Sites+Connections+Report"

export const ALL_SITE_CONNECTIONS_REPORT_GRID_TITLE =
  'allSitesConnectionsReport';

export const columns: Column[] = [
  { name: 'repairerGroup', title: 'Group' },
  { name: 'siteCode', title: 'Site Code' },
  { name: 'capsInboundConnection', title: 'CAPS Code' },
  { name: 'accountStatus', title: 'Account Status' },
  { name: 'subscriptionType', title: 'Subscription Type' },
  { name: 'name', title: 'Name' },
  { name: 'address', title: 'Address'},
  { name: 'postcode', title: 'Postcode' },
  { name: 'systemType', title: 'System Type' },
  { name: 'audatex', title: 'Audatex ID' },
  { name: 'capsOutboundConnections', title: 'CAPS Connections' },
  { name: 'admiral', title: 'Admiral' },
  { name: 'allianz', title: 'Allianz' },
  { name: 'coveaCode', title: 'Covea' },
  { name: 'dlgNetwork', title: 'DLG' },
  { name: 'esure', title: 'Esure' },
  { name: 'itasNetwork', title: 'ITAS' },
  { name: 'kindertons', title: 'KINDERTONS' },
  { name: 'lvConnection', title: 'LV' },
  { name: 'nargNetwork', title: 'NARG' },
  { name: 'rsa', title: 'RSA' },
];
